import { bus } from '@/consts'

export default {
  name: 'OutlineButton',
  template: '#outline-button-template',
  props: [
    'route',
    'animate',
    'condensed',
    'evt'
  ],
  data () {
    return {
      outline: false
    }
  },
  methods: {
    handleMouseEnter () {
      bus.$emit('activateBottomLight')
    },
    handleMouseLeave () {
      bus.$emit('deactivateBottomLight')
    }
  },
  mounted () {
    if (this.animate) {
      setTimeout(() => { this.outline = true }, 500)
    }

    bus.$on('outlineButton', () => {
      this.outline = true
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OutlineButton.js